<template>
  <div class="template-container">
    <div class="brand">
      <a id="home"></a>
        <Menu></Menu>
        <div class="container">
            <div class="brand__body">
                <h1 class="brand__title">We build technology for your convenience</h1>
                <p class="brand__desc">Adop Exchange: Full-Stack RTB Solutions</p>
            </div>
        </div>
    </div>
    <a id="technology"></a>
    <div class="advantages">
        <div class="container">
            <div class="advantages__body">
                <h2 class="advantages__title">Our technology is taking care real time bidding ecosystem.</h2>
                <div class="advantages__list">
                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <img src="/static/img/advantages-01.svg" alt="advantages-01" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">Bid Floor MGMT</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <img src="/static/img/advantages-02.svg" alt="advantages-02" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">Smart Bidding</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <img src="/static/img/advantages-03.svg" alt="advantages-03" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">Bid MGMT</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <img src="/static/img/advantages-04.svg" alt="advantages-04" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">Deep Tracking</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <img src="/static/img/advantages-05.svg" alt="advantages-05" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">5M QPS Capacity</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <img src="/static/img/advantages-06.svg" alt="advantages-06" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">Tech Support</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <img src="/static/img/advantages-07.svg" alt="advantages-07" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">Fraud Protection</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <img src="/static/img/advantages-08.svg" alt="advantages-08" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">Analytics</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advantages-banner">
        <div class="container">
            <div class="advantages-banner__list">
                <div class="advantages-banner__item">
                    <div class="advantages-banner__item__preview">
                        <img src="/static/img/advantages-banner-01.svg" alt="advantages-banner-01" class="advantages-banner__item__preview__img" />
                    </div>
                    <h3 class="advantages-banner__item__name">EXPERIENCE</h3>
                    <p class="advantages-banner__item__desc">20 years in Adtech</p>
                </div>

                <div class="advantages-banner__item">
                    <div class="advantages-banner__item__preview">
                        <img src="/static/img/advantages-banner-02.svg" alt="advantages-banner-02" class="advantages-banner__item__preview__img" />
                    </div>
                    <h3 class="advantages-banner__item__name">DEMAND/SUPPLY</h3>
                    <p class="advantages-banner__item__desc">Full-Stack Ad Platform</p>
                </div>

                <div class="advantages-banner__item">
                    <div class="advantages-banner__item__preview">
                        <img src="/static/img/advantages-banner-03.svg" alt="advantages-banner-01" class="advantages-banner__item__preview__img" />
                    </div>
                    <h3 class="advantages-banner__item__name">ENTERPRISE</h3>
                    <p class="advantages-banner__item__desc">White Label Solution</p>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Menu from './menu'

export default {
  name: 'Home',
  components: {
    Menu
  },
  data () {
    return {
      logget: this.$store.getters.isAuthenticated
    }
  },
  head: {
    title: {
      inner: 'Home',
      separator: '-',
      complement: 'Adop Exchange'
    },
    meta: [
      {
        name: 'description',
        content: 'We build technology for your convenience'
      },
      {
        name: 'keywords',
        content: ''
      },
      {
        property: 'og:title',
        content: 'Adop Exchange'
      },
      {
        property: 'og:image',
        content: 'https://adop.co/static/favicon/android-icon-192x192.png'
      },
      {
        property: 'og:url',
        content: 'https://adop.co/'
      },
      {
        property: 'og:description',
        content: 'We build technology for your convenience'
      }
    ],
    link: [
      {
        rel: 'canonical',
        h: 'https://adop.co',
        id: 'canonical'
      }
    ]
  },
  mounted: function () {
    if (this.$route.fullPath === '/') {
      window.$('html,body').scrollTop(window.$('#home').offset().top)
    }
    if (this.$route.fullPath === '/technology') {
      window.$('html,body').scrollTop(window.$('#technology').offset().top - 40)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/front/home.vue